import { I as s } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as r, normalizeClass as d, createElementVNode as e } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconGoogleBusinessMessaging",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(s).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return s[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, f = ["aria-label", "data-qa", "aria-hidden"];
function u(t, i, l, m, g, a) {
  return n(), r("svg", {
    "aria-label": l.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--google-business-messaging"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Google Business Messaging",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...i[0] || (i[0] = [
    e("path", {
      d: "M20.331 7.245A6.191 6.191 0 0 0 14.312 2.5H7.939a6.187 6.187 0 0 0-4.252 10.683z",
      fill: "#86a9ff"
    }, null, -1),
    e("path", {
      d: "M3.686 13.182A6.114 6.114 0 0 0 5.29 16.01l6.369 6.369a.42.42 0 0 0 .717-.298v-4.205h3.688a6.187 6.187 0 0 0 6.186-6.294 6.106 6.106 0 0 0-1.919-4.337z",
      fill: "#578cff"
    }, null, -1),
    e("path", {
      d: "M14.313 14.875a6.187 6.187 0 0 0 6.018-7.63 6.337 6.337 0 0 0-4.37-1.745H9.687A6.187 6.187 0 0 0 3.5 11.688a6.1 6.1 0 0 0 .186 1.494 6.167 6.167 0 0 0 4.251 1.693z",
      fill: "#0057cc"
    }, null, -1)
  ])], 10, f);
}
const b = /* @__PURE__ */ o(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=google-business-messaging.js.map
